import { useState } from "react";
import type { FormEvent } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { api } from "../api";
import type { Device } from "../api";

/** Link a device to this account. Reached from the QR code on the label
 *  (`/claim?d=BL-…&c=…`, pre-filled) or by typing both in. */
export function Claim() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [deviceId, setDeviceId] = useState(params.get("d") ?? "");
  const [code, setCode] = useState(params.get("c") ?? "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const device = await api.post<Device>("/api/devices/claim", { device_id: deviceId, claim_code: code });
      navigate(`/devices/${device.id}`, { replace: true });
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  }

  return (
    <form className="card narrow" onSubmit={submit}>
      <h2>Add your BotherLog</h2>
      <p className="muted">Both are on the label on the bottom of the unit.</p>
      <label>
        Device ID
        <input value={deviceId} onChange={(e) => setDeviceId(e.target.value)}
               placeholder="BL-3C84A1F0" required autoCapitalize="characters" />
      </label>
      <label>
        Claim code
        <input value={code} onChange={(e) => setCode(e.target.value)}
               placeholder="7KQ4-MX2P" required autoCapitalize="characters" />
      </label>
      {error && <p className="error">{error}</p>}
      <button className="primary" disabled={busy}>Add device</button>
    </form>
  );
}
